import { sendUserDB } from '@/scripts/dataBase';
import { ActionType } from '@/scripts/dataBase/type';
import { MyStorage } from './MyStorage';

export const myClientStorage = new MyStorage(
  {
    async setItem(key: string, value: any) {
      return sendUserDB(ActionType.setUserData, {
        params: {
          key,
          value,
        },
      });
    },
    async getItem(key: string): Promise<any> {
      return sendUserDB(ActionType.getUserData, {
        params: {
          key,
        },
      }).catch(() => undefined);
    },
    removeItem(key: string) {
      return sendUserDB(ActionType.removeUserData, {
        params: {
          key,
        },
      });
    },
    clear() {},
  },
  '',
  false
);
